<template>
  <button class="remove-btn-style">
    <a class="mr-1" :title="$t('invoice.cancel')" @click="toggleModal"><i class="fa fa-ban color-is-danger color-is-warning" aria-hidden="true"></i></a>
  </button>
</template>

<script>
export default {
  name: 'CancelOrder',

  props: {
    order_uuid: { type: String, required: true }
  },

  methods: {
    toggleModal() {
      Swal.fire({
        title: 'Do you really want to cancel order?',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        reverseButtons: false
      }).then((result) => {
        if (result.value) {
          axios
            .post('/orders/cancel/' + this.order_uuid)
            .then(({ data }) => {
              if (data.success) {
                location.reload();
              }
            });
        }
      });
    }
  }
};
</script>
